import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { $enum } from 'ts-enum-util'
import { ISetShipperAppointmentPreferenceInput, Maybe } from 'types/graphqlTypes'
import { IShipperAppointmentPreferenceQuery } from '../graphql/ShipperAppointmentPreference'
import { EditShipperAppointmentsPreferencesSchemaType } from './EditShipperAppointmentsPreferencesSchema'

export const getEditShipperAppointmentsPreferencesRequest = (
  shipperApplicationId: string,
  values: EditShipperAppointmentsPreferencesSchemaType
): ISetShipperAppointmentPreferenceInput => {
  return {
    shipperApplicationId,

    allowAutotender: Boolean(values.allowAutotender),
    buffersEnabled: values.buffersEnabled,
    bufferStopType: values.bufferStopType || null,
    bufferTimeMin: Number.isFinite(values.bufferTimeMin) ? values.bufferTimeMin : null,
    beginEnabled: values.beginEnabled,
    beginDays: Number.isFinite(values.beginDays) ? values.beginDays : null,
    beginBeforeAfter: values.beginBeforeAfter || null,
    beginDate: values.beginDate || null,
    orderEnabled: values.orderEnabled,
    orderStopType: values.orderStopType || null,
    pickupAutoScheduleEnabled: values.pickupAutoScheduleEnabled,
    deliveryAutoScheduleEnabled: values.deliveryAutoScheduleEnabled,
    schedulingInstructions: values.schedulingInstructions || null,
  }
}

export const getDefaultFormValues = (
  data?: IShipperAppointmentPreferenceQuery
): EditShipperAppointmentsPreferencesSchemaType => {
  const { shipperApplication } = data || {}
  const { appointmentPreference } = shipperApplication || {}

  const allowAutotender: 0 | 1 = appointmentPreference?.allowAutotender ? 1 : 0

  return {
    allowAutotender,
    buffersEnabled: Boolean(appointmentPreference?.buffersEnabled),
    bufferStopType: appointmentPreference?.bufferStopType,
    bufferTimeMin: appointmentPreference?.bufferTimeMin ?? null,
    beginEnabled: Boolean(appointmentPreference?.beginEnabled),
    beginDays: appointmentPreference?.beginDays ?? null,
    beginBeforeAfter: appointmentPreference?.beginBeforeAfter,
    beginDate: appointmentPreference?.beginDate,
    orderEnabled: Boolean(appointmentPreference?.orderEnabled),
    orderStopType: appointmentPreference?.orderStopType,
    pickupAutoScheduleEnabled: Boolean(appointmentPreference?.pickupAutoScheduleEnabled),
    deliveryAutoScheduleEnabled: Boolean(appointmentPreference?.deliveryAutoScheduleEnabled),
    schedulingInstructions: appointmentPreference?.schedulingInstructions || '',
  }
}

export const humanizeEnum = (value: Maybe<string>): string =>
  value ? value.split('_').join(' ') : ''

export const enumToSelectOptions = (data: object): TSelectOpt[] =>
  $enum(data).map(value => ({
    label: humanizeEnum(value),
    value,
  }))
